import { MainSection } from "@/styles/global";
import React from "react";
import S from "./AccordionsSmall.styled";
import Arrow from "@/assets/filled-arrow.svg";

export interface AccordionsSmallProps {
  smallAccordionsBlock: {
    title: string;
    ingress: string;
    accordions: {
      videoUrl: string;
      firstTitle: string;
      firstText: string;
      textBlock: {
        text: string;
        title: string;
        titleSize: string;
      }[];
    }[];
  }[];
}

const AccordionsSmall: React.FC<AccordionsSmallProps> = ({
  smallAccordionsBlock,
}) => {
  const [isOpen, setIsOpen] = React.useState([""]);

  const handleOpen = (i: string) => {
    if (isOpen.includes(i)) {
      setIsOpen(isOpen.filter((index) => index !== i));
    } else {
      setIsOpen([...isOpen, i]);
    }
  };

  const renderTitle = (titleSize: string, title: string) => {
    switch (titleSize) {
      case "h5":
        return <S.H5>{title}</S.H5>;
      case "h6":
        return <S.H6>{title}</S.H6>;
      default:
        return <S.H5>{title}</S.H5>;
    }
  };

  const renderAccordions = smallAccordionsBlock?.map(
    ({ title, ingress, accordions }, parentIndex) => {
      const renderAccordion = accordions?.map(
        ({ textBlock, firstText, firstTitle, videoUrl }, childIndex) => {
          const renderTextBlocks = textBlock?.map(
            ({ text, title, titleSize }, index) => {
              return (
                <S.TextBlock key={index}>
                  {title && renderTitle(titleSize, title)}
                  {text && (
                    <S.Text dangerouslySetInnerHTML={{ __html: text }} />
                  )}
                </S.TextBlock>
              );
            }
          );

          return (
            <S.Accordion key={`${parentIndex}-${childIndex}`}>
              <S.AccordionHeader
                onClick={() => handleOpen(`${parentIndex}-${childIndex}`)}
                key={`${parentIndex}-${childIndex}`}
              >
                <S.H5>{firstTitle}</S.H5>
                <S.AccordionArrow
                  $isOpen={isOpen.includes(`${parentIndex}-${childIndex}`)}
                >
                  <Arrow />
                </S.AccordionArrow>
              </S.AccordionHeader>
              <S.AccordionContent
                $isOpen={isOpen.includes(`${parentIndex}-${childIndex}`)}
              >
                {videoUrl && (
                  <S.VimeoHero dangerouslySetInnerHTML={{ __html: videoUrl }} />
                )}
                {firstText && (
                  <S.Text dangerouslySetInnerHTML={{ __html: firstText }} />
                )}
                {renderTextBlocks}
              </S.AccordionContent>
            </S.Accordion>
          );
        }
      );

      return (
        <S.Container key={parentIndex}>
          <S.TextWrapper>
            {title && <S.Title>{title}</S.Title>}
            {ingress && <S.Ingress>{ingress}</S.Ingress>}
          </S.TextWrapper>
          <S.AccordionWrapper>{renderAccordion}</S.AccordionWrapper>
        </S.Container>
      );
    }
  );

  return (
    <MainSection $bgColor="#FCFCFC">
      <S.Inner>{renderAccordions}</S.Inner>
    </MainSection>
  );
};

export default AccordionsSmall;
